import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from 'src/app/base/base.component';

@Component({
  selector: 'app-group-completed',
  templateUrl: './group-completed.component.html',
  styleUrls: ['./group-completed.component.css']
})
export class GroupCompletedComponent extends BaseComponent implements OnInit {

  orderNumber: string = ''
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router) {
    super();
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.orderNumber = params.orderNumber
    })
  }

  goToHome() {
    this.router.navigate(['bottomtabs/home'])
  }

}
